import React from 'react';
import { Table, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { formatDate } from '@/utils/dateHelper';
import {
  columnWhen,
  columnName,
  columnRole,
  columnWhat,
  columnResource,
  columnConsolidatedResource,
  columnSecondaryResource,
  hasColumn,
} from '@/constants/fields';
import SimpleCell from '@/components/table/SimpleCell';
import AuditWhoLink from './AuditWhoLink';
import { auditIcon } from '../constants';
import AuditResourceLink from './AuditResourceLink';

const AuditRow = ({
  allowCohortLink,
  allowCollectionLink,
  allowDatasetLink,
  allowRequestLink,
  allowRoleLink,
  allowSearchLink,
  allowUserLink,
  allowUserGroupLink,
  audit,
  columns = [
    columnWhen,
    columnName,
    columnRole,
    columnWhat,
    columnResource,
  ],
}) => {
  const intl = useIntl();

  return (
    <Table.Row>
      {hasColumn(columns, columnWhen) && (
        <Table.Cell>
          <Icon
            className="primary"
            name={auditIcon(audit.primary_entity)}
            title={intl.formatMessage({ id: `icon.audit.${audit.primary_entity}` })}
          />
          {formatDate(audit.when)}
        </Table.Cell>
      )}
      {hasColumn(columns, columnName) && (
        <Table.Cell>
          <AuditWhoLink allowUserLink={allowUserLink} allowUserGroupLink={allowUserGroupLink} audit={audit} />
        </Table.Cell>
      )}
      {hasColumn(columns, columnRole) && (
        <Table.Cell>
          <AuditResourceLink name={audit.as} route={audit.role_route} allowRoleLink={allowRoleLink} entity="role" />
        </Table.Cell>
      )}
      {hasColumn(columns, columnWhat) && (<SimpleCell content={audit.what} />)}
      {hasColumn(columns, columnResource) && (
        <Table.Cell>
          <AuditResourceLink
            allowCohortLink={allowCohortLink}
            allowCollectionLink={allowCollectionLink}
            allowDatasetLink={allowDatasetLink}
            allowRequestLink={allowRequestLink}
            allowRoleLink={allowRoleLink}
            allowSearchLink={allowSearchLink}
            allowUserGroupLink={allowUserGroupLink}
            allowUserLink={allowUserLink}
            entity={audit.primary_entity}
            name={audit.primary_name}
            route={audit.primary_route}
          />
        </Table.Cell>
      )}
      {hasColumn(columns, columnConsolidatedResource) && (
        <Table.Cell>
          {
            audit.secondary_entity && (
              <AuditResourceLink
                allowCohortLink={allowCohortLink}
                allowCollectionLink={allowCollectionLink}
                allowDatasetLink={allowDatasetLink}
                allowRequestLink={allowRequestLink}
                allowRoleLink={allowRoleLink}
                allowSearchLink={allowSearchLink}
                allowUserGroupLink={allowUserGroupLink}
                allowUserLink={allowUserLink}
                entity={audit.primary_entity}
                name={audit.primary_name}
                route={audit.primary_route}
              />
            )
          }
        </Table.Cell>
      )}
      {hasColumn(columns, columnSecondaryResource) && (
        <Table.Cell>
          <AuditResourceLink
            allowCollectionLink={allowCollectionLink}
            allowDatasetLink={allowDatasetLink}
            allowRequestLink={allowRequestLink}
            allowRoleLink={allowRoleLink}
            allowSearchLink={allowSearchLink}
            allowUserGroupLink={allowUserGroupLink}
            allowUserLink={allowUserLink}
            entity={audit.secondary_entity}
            name={audit.secondary_name}
            route={audit.secondary_route}
          />
        </Table.Cell>
      )}
    </Table.Row>
  );
};

export default AuditRow;
